export const buildTestTypeArr = (moneyMgmtTest) => {

    let testTypeArr = [];
    if (moneyMgmtTest.length > 0){
        for (let i=0; i<moneyMgmtTest.length; i++){
            let testType = "pre-test";
            if (moneyMgmtTest[i].testType){
                testType = moneyMgmtTest[i].testType;
            }
            let pctCorrect = 0
            if (moneyMgmtTest[i].nbrQuestions > 0){
                pctCorrect = ((moneyMgmtTest[i].nbrCorrect / moneyMgmtTest[i].nbrQuestions) * 100).toFixed(2);
            }
            const testObj = {testType: testType, pctCorrect: pctCorrect, 
                gameNbrMonths: moneyMgmtTest[i].gameNbrMonths };
            testTypeArr.push(testObj);
            
        }
    }
    return testTypeArr;
}
export default buildTestTypeArr;